
import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";
import cart from "./modules/cart";
import toast from "./modules/toast";


Vue.use(Vuex);

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",

  modules: {
    auth,
    cart,
    toast
  },

  state: {
    appName: "ProduPneu",
  },

  getters: {
    appName: (state) => state.appName,
  },
});

export default store;
